import dayjs from "dayjs";
export function toDateOnly(date) {
    if (date) {
        return dayjs(date).format("YYYY-MM-DD");
    }
    return undefined;
}
export function toDateTime(date) {
    if (date) {
        return dayjs(date).format("YYYY-MM-DD HH:mm:ss");
    }
    return undefined;
}
export function isSameOrAfter(date, afterDate) {
    return date.isAfter(afterDate, "day") || date.isSame(afterDate, "day");
}
export function isSameOrBefore(date, beforeDate) {
    return date.isBefore(beforeDate, "day") || date.isSame(beforeDate, "day");
}
